import { create } from "zustand";
import axios from "axios";
import addressStore from "./addressStore";
import couponStore from "./couponStore";
import cartStore from "./cartStore";
import Cookies from "js-cookie";

const paymentStore = create((set) => ({
  paymentDetails: null,
  isLoading: true,
  isPaymentLoading: false,
  usedCouponByUser: null,

  setIsPaymentLoading: ({ value }) => {
    set({ isPaymentLoading: value });
  },

  setPaymentDetailsNull: () => {
    set({ paymentDetails: null });
  },

  createPayment: async ({
    razorpay_order_id = null,
    razorpay_payment_id = null,
    razorpay_signature = null,
    paymentType,
  }) => {
    try {
      const { subTotalAmount, discountAmount, couponAmount, totalAmount } =
        cartStore.getState();

      const { copyCouponCode } = couponStore.getState();
      const { selectedAddress } = addressStore.getState();
      const res = await axios.post("/site/create-payment", {
        subTotal: subTotalAmount,
        discount: discountAmount,
        couponDiscount: couponAmount,
        total: totalAmount,
        paymentType,
        couponID: couponAmount !== 0 ? copyCouponCode._id : null,
        addressID: selectedAddress._id,
        razorpay_order_id,
        razorpay_payment_id,
        razorpay_signature,
      });

      if (res) {
        const { paymentDetails } = paymentStore.getState();
        const data = paymentDetails ? paymentDetails : [];
        data.push(res.data.paymentDetail);
        set({ paymentDetails: data });
        return res.data.paymentDetail._id;
      }
    } catch (error) {
      console.log(error);
    }
  },

  fetchAllUserPayments: async () => {
    try {
      const { setUsedCouponByUser } = paymentStore.getState();
      const res = await axios.get("/site/fetch-all-user-payment");
      if (res.data.paymentDetail.length) {
        set({ paymentDetails: res.data.paymentDetail });
        await setUsedCouponByUser({ paymentDetail: res.data.paymentDetail });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  setUsedCouponByUser: async ({ paymentDetail }) => {
    try {
      const data = [];
      paymentDetail.map((item) => {
        if (item.couponID) {
          data.push(item.couponID);
        }
      });
      if (data.length) {
        set({ usedCouponByUser: data });
      }
    } catch (error) {
      console.log(error);
    }
  },

  getPaymentWithOrderDetails: async ({ id }) => {
    try {
      const res = await axios.get(`/site/get-payment-with-order-details/${id}`);
      return res.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  },
}));

export default paymentStore;
